export default function readCookie(type) {
    return new Promise(function(resolve) {
        jQuery.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            data: {
                landing_type: type,
            },
            type: 'POST',
            url: '/get-button-hidden',
            cache: false,
            dataType: 'json',
            success: function (response) {
                resolve(response.status);
            },
        });
    });
}
